import moment from 'moment-timezone';
import type { RoomsOperatingReport } from 'model/RoomsOperatingReport';

export enum RoomsOperatingReportStatus {
    Initial = 'Initial',
    Getting = 'Getting',
    GettingSuccess = 'GettingSuccess',
    Error = 'Error'
}

const emptyRange = () => ({
    start: moment.invalid(),
    end: moment.invalid()
});

export const emptyRoomsOperatingReport: RoomsOperatingReport = {
    ranges: {
        today: emptyRange(),
        todayLy: emptyRange(),
        mtd: emptyRange(),
        mtdLy: emptyRange(),
        ytd: emptyRange(),
        ytdLy: emptyRange()
    },
    summary: {
        roomsAvailable: 0,
        roomsOccupied: { value: 0, pct: 0 },
        vacantRooms: { value: 0, pct: 0 },
        petsServed: 0,
        adr: 0,
        revpar: 0,
        totalRoomRevenue: 0
    },
    metrics: []
};

export interface RoomsOperatingReportState {
    report: RoomsOperatingReport;
    status: RoomsOperatingReportStatus;
    loading: boolean;
}
